import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import EntityProfileOverview from '@/views/probaworkflows_base/management/compliance_management/entity_profile_overview/EntityProfileOverview.vue';
import ViewComplianceChecks from '@/views/probaworkflows_base/management/compliance_management/view_compliance_checks/ViewComplianceChecks.vue';
import ComplianceNotifications from '@/views/probaworkflows_base/management/compliance_management/compliance_notifications/ComplianceNotifications.vue';
export default {
  name: "ViewTrustCompliance",
  components: {
    EntityProfileOverview,
    ViewComplianceChecks,
    NavigationBackButton,
    ComplianceNotifications,
  },
  data: () => ({
    active_tab: "Compliance Overview", // Default active tab
    tabs: [
      "Forms",
      "Compliance Overview",
      "Notifications" // Add this for the new tab
    ],
    entity_id: null,      // Add this to store the entity_id
    entity_type_name: null // Add this if you need the entity type
  }),
  mounted() {
    // Get the entity_id from route query when component is created
    this.entity_id = this.$route.query.entity_id;
    this.entity_type_name = this.$route.query.entity_type_name;
  },
  methods: {
    set_active_tab(tab) {
      this.active_tab = tab;
    },
  }
};